import * as GatesCardStyleUtils from 'styles/shared/GatesCardStyleUtils';

export const gatesSummaryHeaderStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  p: 2,
  backgroundColor: GatesCardStyleUtils.GATES_SUMMARY_HEADER_BG,
  border: `1px solid ${GatesCardStyleUtils.GATES_BORDER_LIGHT}`,
  borderRadius: 1
};

export const summaryTypographyStyle = {
  fontSize: '0.875rem',
  fontWeight: 600
};

export const gateContainerStyle = (borderColor: string) => ({
  mt: 2,
  backgroundColor: '#FFFFFF',
  borderLeft: `3px solid ${borderColor}`,
  borderTop: `1px solid ${GatesCardStyleUtils.GATES_BORDER_LIGHT}`,
  borderRight: `1px solid ${GatesCardStyleUtils.GATES_BORDER_LIGHT}`,
  borderBottom: `1px solid ${GatesCardStyleUtils.GATES_BORDER_LIGHT}`,
  borderRadius: '0.5rem'
});

export const gateHeaderStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  mb: 1,
  padding: '0.5rem 1rem 0 1rem'
};

export const gateNameStyle = {
  fontWeight: 600
};

export const modeBadgeStyle = (backgroundColor: string, color: string) => ({
  backgroundColor,
  color,
  fontSize: '0.7rem',
  padding: '0.25rem',
  fontWeight: 600,
  height: 'auto'
});

export const exclusiveBadgeStyle = {
  backgroundColor: GatesCardStyleUtils.APPROVAL_MODE_EXCLUSIVE_BG,
  color: GatesCardStyleUtils.APPROVAL_MODE_EXCLUSIVE_COLOR,
  fontSize: '0.7rem',
  padding: '0.25rem',
  fontWeight: 600,
  height: 'auto'
};

export const rejectedStatusStyle = {
  backgroundColor: GatesCardStyleUtils.GATES_STATUS_REJECTED_BG,
  color: GatesCardStyleUtils.GATES_STATUS_REJECTED,
  fontSize: '0.75rem',
  padding: '0.25rem 0.5rem',
  fontWeight: 600,
  textTransform: 'uppercase'
};

export const clearedStatusStyle = {
  backgroundColor: GatesCardStyleUtils.GATES_STATUS_CLEARED_BG,
  color: GatesCardStyleUtils.GATES_STATUS_CLEARED,
  fontSize: '0.75rem',
  padding: '0.25rem 0.5rem',
  fontWeight: 600,
  textTransform: 'uppercase'
};

export const pendingStatusStyle = {
  backgroundColor: GatesCardStyleUtils.GATES_STATUS_PENDING_BG,
  color: GatesCardStyleUtils.GATES_STATUS_PENDING_COLOR,
  fontSize: '0.75rem',
  padding: '0.25rem 0.5rem',
  fontWeight: 600,
  textTransform: 'uppercase'
};

export const clearedInfoStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  mb: 1,
  padding: '0 1rem'
};

export const clearedLabelStyle = {
  color: GatesCardStyleUtils.GATES_STATUS_CLEARED,
  fontWeight: 600
};

export const clearedCircleStyle = {
  width: '0.1875rem',
  height: '0.1875rem',
  borderRadius: '50%',
  backgroundColor: 'text.secondary'
};

export const currentApproverContainerStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  mb: 1,
  padding: '0 1rem'
};

export const currentApproverTextStyle = {
  color: 'text.secondary',
  fontSize: '0.75rem'
};

export const borderBottomDividerStyle = {
  borderBottom: `1px solid ${GatesCardStyleUtils.GATES_BORDER_DIVIDER}`,
  my: 1
};

export const approversListStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: 0.5,
  padding: '0 1rem 0.5rem 1rem'
};

export const approverRowStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  py: 0.5
};

export const rejectedIconStyle = {
  fontSize: '1rem',
  color: GatesCardStyleUtils.GATES_STATUS_REJECTED
};

export const approvedIconStyle = {
  fontSize: '1rem',
  color: GatesCardStyleUtils.GATES_STATUS_CLEARED
};

export const clockIconStyle = (color: string) => ({
  fontSize: '1rem',
  color
});

export const approvedCircleStyle = {
  width: '0.1875rem',
  height: '0.1875rem',
  borderRadius: '50%'
};

export const notifiedTextStyle = {
  color: GatesCardStyleUtils.GATES_STATUS_NOTIFIED,
  whiteSpace: 'nowrap',
  fontWeight: 600
};

export const waitingTextStyle = {
  color: GatesCardStyleUtils.GATES_STATUS_WAITING,
  whiteSpace: 'nowrap'
};

export const rejectedInfoStyle = {
  borderTop: `1px solid ${GatesCardStyleUtils.GATES_BORDER_DIVIDER}`,
  mt: 1,
  pt: 1
};

export const rejectedLabelStyle = {
  color: GatesCardStyleUtils.GATES_STATUS_REJECTED,
  fontWeight: 600
};

export const rejectedCommentStyle = {
  display: 'flex',
  alignItems: 'start',
  marginTop: '0.25rem',
  padding: '0.25rem 0.5rem',
  borderRadius: '0.25rem',
  backgroundColor: GatesCardStyleUtils.GATES_STATUS_COMMENT_BG,
  border: `1px solid ${GatesCardStyleUtils.GATES_STATUS_COMMENT_BORDER}`,
  color: '#991b1b'
};
